import "./index.css";

import { createTheme, ThemeProvider } from "@mui/material";
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { RecoilRoot } from "recoil";
import { SWRConfig } from "swr";
import CookiesBanner from "./components/CookiesBanner";
import NavBar from "./components/NavBar";
import { Fetcher } from "./network";
import Router from "./router";
import { GetSession } from "./utils/CheckSession";
import ScrollToTop from "./utils/ScrollToTop";

// Create a custom theme with a custom primary color.
const theme = createTheme({
  palette: {
    primary: {
      main: "#BED701",
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <SWRConfig value={{ fetcher: (url) => Fetcher(url, GetSession()) }}>
    <ThemeProvider theme={theme}>
      <BrowserRouter>
        <RecoilRoot>
          <NavBar />
          <ScrollToTop />
          <Router />
          <CookiesBanner />
        </RecoilRoot>
      </BrowserRouter>
    </ThemeProvider>
  </SWRConfig>
);
